import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, QuoteIcon } from 'lucide-react';
const audience = ['Sentís ansiedad o estrés con frecuencia.', 'Querés fortalecer tu autoestima.', 'Buscás comprender mejor tus emociones.', 'Querés dejar atrás el autosabotaje.', 'Deseás mejorar tus relaciones.', 'Buscás una formación clara, práctica y organizada.'];
export function CostOfInaction() {
  return <section className="bg-ink px-4 py-20 text-white md:py-28" data-id="element-27" data-mp="34wted26622dp">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-28" data-mp="34u73otnzb6r9">
        <motion.div initial={{
        opacity: 0,
        x: -18
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-29" data-mp="3dobpuzs63u0g">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-clay text-white" data-id="element-30" data-mp="3ipizz5hs95aa">
            <QuoteIcon className="h-6 w-6" aria-hidden="true" data-id="element-31" data-mp="3nkev4eibg8rm" />
          </div>
          <p className="mt-7 text-sm font-bold uppercase tracking-[0.15em] text-rose" data-id="element-32" data-mp="3sm43tni2gacj">Una formación para el día a día</p>
          <h2 className="mt-3 font-heading text-4xl font-semibold leading-tight md:text-5xl" data-id="element-33" data-mp="3eeddv6nsh3gx">
            Esta formación es para vos si buscás sentirte mejor con vos mismo.
          </h2>
          <p className="mt-6 max-w-md text-base leading-7 text-white/70" data-id="element-34" data-mp="34ik1bna2l9z5">
            No necesitás tener conocimientos previos. El método organiza herramientas y reflexiones para que avances con claridad, a tu propio ritmo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 18
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="rounded-2xl border border-white/15 bg-white/5 p-6 md:p-8" data-id="element-35" data-mp="3s7l34roedmvg">
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-36" data-mp="3jdghcmo4f1ms">
            {audience.map(item => <li key={item} className="flex gap-3 text-sm leading-6 text-white/85" data-id="element-37" data-mp="jsunndl3ru81">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose text-ink" data-id="element-38" data-mp="f09veghuhp6m">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-39" data-mp="299oqt11mslzg" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}